module.exports = __webpack_public_path__ + "img/product-icon.dd7beb78.svg";